import type { DefaultValues, SubmitHandler } from 'react-hook-form';
import { forwardRef } from 'react';
import { isFunction } from 'lodash';
import { useForm } from 'react-hook-form';

import type { IContentBlockFormBodyProps } from '~/components/molecules/ContentBlock';
import type { IContainerProps } from '~/components/utils/Container';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { UserContentReviewListFilterFormMainSection } from './UserContentReviewListFilterFormMainSection';

export type IUserContentReviewListFilterFormBodyValues = {
  toReview?: boolean;
  reported?: boolean;
  moderated?: boolean;
  ugcId?: string;
  userId?: string;
  parentId?: string;
  type?: 'comment' | 'article';
};

export type IUserContentReviewListFilterFormBodyRenderProps = {
  form: ReturnType<typeof useForm<IUserContentReviewListFilterFormBodyValues>>;
};

export type IUserContentReviewListFilterFormBodyProps = IContainerProps &
  Omit<
    IContentBlockFormBodyProps<IUserContentReviewListFilterFormBodyValues>,
    'form' | 'children' | 'onSubmit' | 'submitting'
  > & {
    form?: ReturnType<
      typeof useForm<IUserContentReviewListFilterFormBodyValues>
    >;
    defaultValues?: DefaultValues<IUserContentReviewListFilterFormBodyValues>;
    onSubmit?: SubmitHandler<IUserContentReviewListFilterFormBodyValues>;
    appId: string;
    children?:
      | React.ReactNode
      | ((
          props: IUserContentReviewListFilterFormBodyRenderProps,
        ) => React.ReactNode);
  };

export const UserContentReviewListFilterFormBody = forwardRef<
  HTMLFormElement,
  IUserContentReviewListFilterFormBodyProps
>(function SearchModerationForm(props, ref) {
  const {
    sx,
    form: formProp,
    defaultValues,
    onSubmit,
    appId,
    children,
    ...other
  } = props;
  const ownForm = useForm<IUserContentReviewListFilterFormBodyValues>({
    defaultValues,
  });
  const form = formProp ?? ownForm;

  return (
    <ContentBlock.FormBody
      ref={ref}
      sx={sx}
      form={form}
      onSubmit={onSubmit}
      hideActionBar
      {...other}
    >
      <UserContentReviewListFilterFormMainSection form={form} appId={appId} />

      {isFunction(children) ? children({ form }) : children}
    </ContentBlock.FormBody>
  );
});
